module.exports = __webpack_public_path__ + "armchair.84b1b89e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/armchair.png
// module id = 1742
// module chunks = 0